import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/button/style";
import _Button from "vant/es/button";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/popover/style";
import _Popover from "vant/es/popover";
import "vant/es/action-sheet/style";
import _ActionSheet from "vant/es/action-sheet";
import "vant/es/tabs/style";
import _Tabs from "vant/es/tabs";
import "vant/es/tab/style";
import _Tab from "vant/es/tab";
import "core-js/modules/es.array.push.js";
import vote from '../vote/index.vue';
import Vue from 'vue';
import qs from 'qs';
import _ from 'lodash';
import get from '@/api/get';
import * as _code from '../../utils/code';
import message from '../message';
import allReplyList from './page/allReplyList.vue';
import emjoy from '../emjoy/emjoy.vue';
import largerVersion from '../detailsPage/page/largerVersion.vue';
import shareBounced from '../detailsPage/page/shareBounced.vue';
import sideRight from '@/components/sideRight';
import getTime from '../../utils/time';
import { mapState } from 'vuex';
import { debounce } from 'lodash';
import arrNewSet from '@/utils/arrNewSet';
import numberFormat from '@/utils/numberFormat';
Vue.use(_Tab);
Vue.use(_Tabs);
Vue.use(_ActionSheet);
Vue.use(_Popover);
import levelIcon from '@/components/task/levelIcon.vue';
export default {
  name: 'topicPage',
  components: {
    shareBounced,
    largerVersion,
    [_Icon.name]: _Icon,
    [_Button.name]: _Button,
    message,
    allReplyList,
    sideRight,
    emjoy,
    levelIcon,
    vote
  },
  data() {
    return {
      sortTypeNum: 1,
      dynamicComponent: null,
      loadingFlag: false,
      emojiFlag: false,
      postsPosterId: '',
      routerTopicId: '',
      //用于记录缓存详情页的topicId，当有缓存时，进入其他贴子详情页，先删除缓存
      isComment: true,
      //评论or回复评论
      currentFloorIndex: '',
      //当前评论楼层，用于定向更新评论
      applets: window.user.weixcode ? 'xcx' : '',
      applets_first: false,
      poster: false,
      //判断是否回复一楼
      flag: true,
      defaultImg: this.$store.state.gameType != 1 ? 'https://media.tentree-games.com/media/pictures/community/img/header.webp' : 'https://media.zlongame.com/media/pictures/cn/community/img/lzg_header.png',
      shareShow: false,
      shareData: '',
      typographyImg: '',
      imgcurrindex: 0,
      largerFlag: false,
      largerImgList: [],
      msgWrapImg: '',
      msgImgShow: false,
      imgList: [],
      videoLList: [],
      imgCross: '',
      bigmsgWrap: '',
      allReplyListId: 0,
      objectsAre: {},
      objectsAre2: {},
      replyValue: '',
      bottomFlag: true,
      messagereplyFlag: true,
      user: {},
      //储存当前帖子及用户信息
      commentsId: '',
      mongoliaFlag: false,
      allReplyFlag: false,
      likeClickFlag: '',
      commentList: [],
      commentList2: [],
      commentsFlag: false,
      show: false,
      show_complaints: false,
      actions: [],
      actions_complaints: [{
        name: '广告或垃圾消息'
      }, {
        name: '淫秽色情'
      }, {
        name: '政治敏感'
      }, {
        name: '人身攻击'
      }],
      sortType: '倒序',
      showPopover: false,
      sortActions: [{
        text: '正序'
      }, {
        text: '倒序'
      }, {
        text: '热点排序'
      }],
      sortOffset: [20, 0],
      msg: '',
      serverName: '区服1',
      likeNum: '10',
      msgTime: '3分钟前',
      topUserInfo: false,
      msgTo: '楼主',
      msgToOther: false,
      msgToOtherImg: '',
      isLoading: false,
      //评论下拉刷新
      msgLoading: false,
      msgFinished: false,
      msgPageNo: 1,
      anchorFlag: false,
      //锚点

      file1: 'file',
      //input数据类型
      qaFlag: /^(test|qa)-/.test(location.hostname),
      Bucket: '',
      Region: '',
      allowPrefix: '',
      protocol: 'https:',
      windowInnerHeight: '',
      curReplyMemberNickName: '',
      //回复人姓名 造假数据用
      postingFlag: '',
      isVideoPost: false,
      jumpTopicId: '',
      //游戏内跳转帖子id（获取评论用,this.user.id）
      topPoster: ''
    };
  },
  computed: {
    ...mapState({
      token: 'token'
    })
  },
  watch: {
    token(ne, ol) {
      this.getDetail(); //获取帖子详情
    },
    show(n, o) {
      if (!n) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
    },
    shareShow(n, o) {
      if (!n) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
    },
    show_complaints(n, o) {
      if (!n) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
    }
  },
  // created() {
  //   this.getDetail(); //获取帖子详情
  // },
  mounted() {
    let _this = this;
    // if (this.$route.name == 'topicPage') {
    //   if (this.$store.state.system == 'u3dPc') {
    //     setTimeout(() => {
    //       // eslint-disable-next-line no-undef
    //       $('.publishedContent').on('click', '.publishedCon', function () {
    //         // eslint-disable-next-line no-undef
    //         var videoUrl = $('.publishedContent .publishedCon #video').attr(
    //           'src'
    //         );
    //         var count = 3000;
    //         var pace = 50;
    //         setTimeout(function () {
    //           try {
    //             window.gotoUrl(videoUrl);
    //           } catch (err) {
    //             count = count - pace;
    //             if (count >= 0) {
    //               arguments.callee();
    //             }
    //           }
    //         }, pace);
    //       });
    //     }, 1000);
    //   }
    // }
    this.$preview.on('close', (e, item) => {
      //图片大图关闭事件
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
      }
    });
    this.$preview.on('imageLoadComplete', (e, item) => {
      let _preview = this.$preview.self;
      let lookUrl = window.location.href + '&look';
      window.history.pushState(null, null, lookUrl);
      _preview.listen('close', function () {
        if (window.location.href.indexOf('&look') !== -1) {
          window.history.back();
        }
      });
      window.onhashchange = function () {
        if (_preview !== null && _preview !== undefined) {
          _preview.close();
          _preview = null;
          //图片大图关闭事件
          if (_this.$store.state.system == 'iphone') {
            window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
          }
        }
      };
    });
    this.$route.query.appletsFirst ? this.applets_first = true : '';
    if (this.$store.state.token) {
      // this.getDetail(); //获取帖子详情
    }
    window.addEventListener('scroll', this.scrollFun);
    // 是否需要锚点
    this.anchorFlag = this.$store.state.anchorFlag;
    this.windowInnerHeight = window.innerHeight - $('.detailsPage_bottombox').height();
    this.postingFlag = this.$store.state.postingFlag;
  },
  //处理详情页缓存
  activated() {
    this.getDetail(); //获取帖子详情
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      $('video').attr('controlslist', 'nodownload');
    }, 2000);
    if (this.routerTopicId != '') {
      if (this.routerTopicId != this.$route.query.topicId) {
        this.$route.meta.keepAlive = false;
        this.$parent.$forceUpdate();
      }
    }
  },
  //处理详情页指定缓存
  beforeRouteLeave(to, from, next) {
    if (to.name == 'otherHome') {
      this.routerTopicId = this.$route.query.topicId;
      this.$route.meta.keepAlive = true;
    } else {
      this.$parent.clearCache(this);
    }
    this.$store.commit('changeAnchorFlag', false);
    next();
  },
  methods: {
    tabSort(num) {
      this.msgPageNo = 1;
      this.sortTypeNum = num;
      this.commentList = [];
      this.getList();
    },
    createDynamicComponent(str) {
      // 将字符串转换为模板
      const templateString = this.replaceVoteTag(str);
      // 动态定义一个新组件
      this.dynamicComponent = Vue.extend({
        template: templateString,
        components: {
          shareBounced,
          largerVersion,
          [_Icon.name]: _Icon,
          [_Button.name]: _Button,
          message,
          allReplyList,
          sideRight,
          emjoy,
          levelIcon,
          vote // 确保注册你的 Vote 组件
        },
        methods: {
          imgClick() {
            // this.$parent.imgClick();
            if (this.$store.state.system == 'iphone') {
              window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
            }
          }
        }
      });
    },
    replaceVoteTag(str) {
      str = `<div class='publishedCon'>${str}</div>`;
      return str.replace(/\{vote id="(\d+)" value=":pas\+\{3M~Syn@G\{0"\}/g, "<vote voteid='$1'></vote>");
    },
    toPartition(item) {
      this.$router.push({
        name: 'partitionPage',
        query: {
          id: item.partitionId,
          subjectName: item.partitionName
        }
      });
    },
    goUrl(url) {
      var count = 3000;
      var pace = 50;
      let isQa = /^(test|qa)-/.test(location.hostname);
      let pageUrl = 'https://' + (isQa ? 'qa-' : '') + 'www.sugarfungame.com/actv/communityVideo/index.html?id=';
      setTimeout(function () {
        try {
          window.gotoUrl(pageUrl + url);
        } catch (err) {
          count = count - pace;
          if (count >= 0) {
            arguments.callee();
          }
        }
      }, pace);
    },
    getShare() {
      // if (this.$store.state.loginStatus == 0) {
      //   this.$store.commit('changeLoginShow', true);
      // } else {
      // }
      this.shareShow = true;
    },
    //表情包功能模块
    deleteClick() {
      let _this = this;
      let len = `${_this.replyValue.match(/\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,3}_(\d){1,2}_(\d{1,3})\]$/g, function (a) {
        return a;
      })}`.length;
      if (len == 4) {
        _this.replyValue = _this.replyValue.slice(0, -1);
      } else {
        _this.replyValue = _this.replyValue.slice(0, -len);
      }
    },
    pushvalue(imgvalue) {
      let _this = this;
      let elInput = document.getElementById('replyCon');
      let startPos = elInput.selectionStart;
      let endPos = elInput.selectionEnd;
      if (endPos === 0 && _this.replyValue == '') {
        _this.replyValue = this.$refs.emjoy.changeValue(imgvalue);
      } else {
        let txt = _this.replyValue;
        let result = txt.substring(0, startPos) + this.$refs.emjoy.changeValue(imgvalue) + txt.substring(endPos);
        _this.replyValue = result;
      }
      if (this.$padFalg != 'other') {
        this.emojiClick();
      }
      if (this.$store.state.system == 'iphone') {
        _this.$nextTick(() => {
          elInput.focus();
          elInput.selectionStart = startPos + _this.replyValue.length;
          elInput.selectionEnd = startPos + _this.replyValue.length;
        });
      }
    },
    //关闭弹出层底部页面滑动
    closeBodyScroll() {
      window.lockMaskScrollTop = document.scrollingElement.scrollTop || document.body.scrollTop;
      document.body.classList.add('open');
      // document.body.style.top = -window.lockMaskScrollTop + "px";
      // eslint-disable-next-line no-undef
      $('video').removeAttr('controls');
    },
    //打开弹出层底部页面滑动
    openBodyScroll() {
      if (document.body.classList.contains('open')) {
        document.body.classList.remove('open');
        // document.scrollingElement.scrollTop = window.lockMaskScrollTop;
      }
    },
    //底部input获取焦点事件
    inputFocus(objectsAre, id) {
      if (this.$store.state.system !== 'iphone') {
        this.emojiFlag = false;
      }
      this.openBodyScroll();
      if (id == 1) {
        this.objectsAre = objectsAre;
      }
    },
    inputonblur() {
      this.closeBodyScroll();
    },
    emojiClick() {
      this.emojiFlag = !this.emojiFlag;
    },
    handleSelection() {
      if (this.$refs.emjoy) {
        this.$refs.emjoy.handleSelection();
      }
    },
    changeValue() {
      //评论内容表情包转换
      let str = this.$refs.uploadinput_div.innerHTML;
      let imgReg = /<img.*?(?:>|\/>)/gi;
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
      let arr = str.match(imgReg);
      arr.forEach((item, i) => {
        var src = arr[i].match(srcReg);
        let srcArr = src[1].split('emjoy')[1].split('/');
        //获取图片地址
        switch (srcArr[1]) {
          case 'dragon':
            str = str.replace(item, `[zlemoji=lzg_0_${srcArr[2].split('.')[0]}][/zlemoji]`);
            break;
          case 'littleDragon':
            str.replace(item, `[zlemoji=lzg_1_${srcArr[2].split('.')[0]}][/zlemoji]`);
            break;
          default:
            break;
        }
      });
      return str;
    },
    defImg() {
      //图片错误展示默认图片
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
    //分享弹出框显示及关闭
    shareShowFlag(flag) {
      this.shareShow = flag;
    },
    scrollFun() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // this.topUserInfo =
      //   scrollTop > $(".publishedContent").offset().top? true : false;
    },
    imgInit() {
      //图片初始化展示
      let _this = this;
      if (JSON.stringify(_this.imgList) != '[]') {
        if (_this.imgList.length == 1) {
          let img = new Image();
          img.src = _this.imgList[0].path;
          img.onload = function () {
            if (img.height >= img.width) {
              _this.imgCross = 'card_publishedContent_imgboxVertical';
            } else {
              _this.imgCross = 'card_publishedContent_imgboxCross';
            }
          };
        } else if (_this.imgList.length == 4) {
          this.typographyImg = 'card_publishedContent_imgbigboxFour';
          this.imgCross = 'card_publishedContent_imgboxFour';
        } else {
          this.typographyImg = 'card_publishedContent_imgbigbox';
          this.imgCross = 'card_publishedContent_imgboxFour';
        }
      }
    },
    //点击图片全屏
    imgClick(flag, list, index) {
      if (this.$store.state.system == 'iphone') {
        window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
      }
      // if (flag) {
      //   this.largerImgList = list;
      //   this.imgcurrindex = index;
      //   this.largerFlag = flag;
      //   if (this.$store.state.system == "iphone") {
      //     window.location.href = "iosn://pd_bbs_actv_hideClose?hideCloseFlag=1";
      //   }
      // } else {
      //   this.largerFlag = flag;
      //   if (this.$store.state.system == "iphone") {
      //     window.location.href = "iosn://pd_bbs_actv_hideClose?hideCloseFlag=0";
      //   }
      // }
    },
    //去用户点赞列表
    goGoodList(id) {
      this.$router.push({
        name: 'listPage',
        query: {
          type: 'good',
          id: id
        }
      });
    },
    //去用户主页
    goUserPage(id) {
      // if (this.$store.state.loginStatus == 1) {
      this.$router.push({
        name: 'otherHome',
        query: {
          id: id
        }
      });
      // } else {
      //   this.$store.commit('changeLoginShow', true);
      // }
    },
    submit: debounce(function () {
      if (this.$store.state.postingFlag) {
        if (this.replyValue.trim() == '' && this.msgWrapImg == '') {
          _Toast('内容不能为空');
          return;
        }
        // this.getDetail();
        this.inputblur();
        let obj = {
          content: this.replyValue,
          pictures: this.msgWrapImg ? JSON.stringify([{
            path: this.msgWrapImg
          }]) : '',
          commentId: JSON.stringify(this.objectsAre) != '{}' ? this.objectsAre.id : '',
          replyMemberId: this.poster ? 0 : JSON.stringify(this.objectsAre2) != '{}' ? this.objectsAre2.memberId : ''
        };
        get.topicComment(this.user.id, qs.stringify(obj)).then(res => {
          let data = res.data;
          if (data.code == 0) {
            if (this.isComment) {
              //是评论
              this.msgOnLoad(false, true);
              this.inputblur();
            } else {
              //回复评论
              this.msgPageNo = parseInt(this.currentFloorIndex / 10) == this.currentFloorIndex / 10 ? this.currentFloorIndex / 10 : parseInt(this.currentFloorIndex / 10) + 1;
              let obj = {
                memberAvatar: '',
                //头像
                memberId: '',
                //用户id
                isOfficial: '',
                replyMemberNickName: this.curReplyMemberNickName,
                //回复人名称、、、、、、
                memberNickName: '',
                //用户名
                memberAuthInfo: '',
                //认证
                postsPosterId: this.user.memberId,
                //楼主id
                content: this.replyValue,
                //评论内容
                createTime: '刚刚',
                //时间
                id: data.data,
                //评论id
                likeNum: 0,
                //点赞数量
                isLike: 0 //是否点赞
              };
              obj.content = obj.content.replace(/\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,7}_(\d){1,2}_(\d{1,3})\]/g, (a, b, c) => {
                console.log(a, b, c);
                return this.getEmjoy(b, c);
              });
              get.getProfile().then(res => {
                let data = res.data.data;
                obj.memberAvatar = data.avatar;
                obj.memberNickName = data.nick_name;
                obj.isOfficial = data.isOfficial;
                obj.memberId = data.id;
                obj.memberAuthInfo = data.auth_info;
                this.$refs.message[this.currentFloorIndex].changeReplyCommentList(obj);
              });
            }
            _Toast.success('發布成功');
            this.msgWrapImg = '';
            this.objectsAre = {};
            this.objectsAre2 = {};
            this.replyValue = '';
            if (this.user.commentNum.toString().indexOf('万') == -1) {
              this.user.commentNum++;
            }
          } else {
            this.errorMessage(data);
          }
        });
      } else {
        _Toast('功能维护中，暂不支持回复');
      }
    }, 1000, {
      leading: true,
      trailing: false
    }),
    getEmjoy(params, name) {
      let imgclass = '';
      switch (this.$store.state.gameType) {
        case 1:
          //龙之国
          switch (params) {
            case '0':
              imgclass = 'role';
              break;
            case '1':
              imgclass = 'dragon';
              break;
            case '2':
              imgclass = 'littleDragon';
              break;
            default:
              break;
          }
          break;
        case 2:
          //钢岚
          imgclass = 'gl/role';
          break;
        case 3:
          //第七史诗
          imgclass = 'dqss/role';
          break;
        default:
          break;
      }
      return `<img class='emjoy' src=https://media.zlongame.com/media/pictures/cn/community/img/emjoy/${imgclass}/${name}.png>`;
    },
    //回复列表开关
    allReplyChang(flag, id, postsPosterId) {
      if (id) {
        this.allReplyListId = id;
        this.allReplyFlag = flag;
        this.postsPosterId = postsPosterId;
      } else {
        this.allReplyFlag = flag;
      }
    },
    //放大
    getBigmsgWrap() {
      this.bigmsgWrap == '' ? this.bigmsgWrap = 'bigmsgWrap' : this.bigmsgWrap = '';
    },
    //底部输入框点击
    getFocus(aitem, item, poster) {
      // debugger;
      if (this.$store.state.gameType == 2 && this.$store.state.loginStatus == 0) {
        this.$parent.$parent.$refs.login.getTip(1, null);
        this.$store.commit('changeLoginShow', true);
      } else {
        if (item) {
          //是回复评论，不是评论
          this.isComment = false;
          this.currentFloorIndex = this.commentList.findIndex(child => {
            return child.floorNum == item.floorNum;
          });
          this.curReplyMemberNickName = aitem.id == item.id ? '' : item.memberNickName;
        } else {
          this.isComment = true;
        }
        if (this.shareData.canReply != 0 || !this.postingFlag) return;
        if (poster == 'poster' || aitem == 'imgBtn') {
          this.poster = true;
        } else {
          this.poster = false;
        }
        if (this.$store.state.status == 1) {
          _Toast('因违反社区规范被禁言');
          return;
        }
        this.objectsAre = aitem;
        if (aitem !== 'imgBtn') {
          this.objectsAre2 = item;
          this.msgImgShow = true;
        }
        if (!item) {
          this.msgImgShow = false;
          this.msgToOtherImg = this.user.memberAvatar;
          this.msgTo = '回复楼主';
          this.msgToOther = false;
        } else {
          this.msgToOtherImg = item.memberAvatar;
          this.msgTo =
          // item.memberId == item.postsPosterId ? "回复楼主" : item.content;
          item.content;
          this.msgToOther = item.memberId == item.postsPosterId ? false : true;
        }
        this.$nextTick(() => {
          this.mongoliaFlag = true;
          this.bottomFlag = false;
          if (this.bottomFlag) {
            if (this.$store.state.system == 'iphone') {
              window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
            }
          } else {
            if (this.$store.state.system == 'iphone') {
              window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
            }
          }
        });
      }
    },
    //失去焦点
    inputblur(str) {
      if (str && str == 'remove') {
        this.replyValue = '';
      }
      this.bigmsgWrap = '';
      this.mongoliaFlag = false;
      this.bottomFlag = true;
      if (this.bottomFlag) {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=0';
        }
      } else {
        if (this.$store.state.system == 'iphone') {
          window.location.href = 'iosn://pd_bbs_actv_hideClose?hideCloseFlag=1';
        }
      }
      this.$refs.inpIngCon.blur();
      this.emojiFlag = false;
    },
    //关注&取关
    focusClick() {
      get.follow(this.user.memberId).then(res => {
        let data = res.data;
        if (data.code == 0) {
          this.user.isFans = !this.user.isFans;
          this.user.isFans ? this.actions[2].name = `取消关注 ${this.user.memberNickName}` : this.actions[2].name = `关注 ${this.user.memberNickName}`;
          _Toast(data.message);
        } else {
          this.errorMessage(data);
        }
      });
    },
    getDetail() {
      // 获取帖子详情

      // if(this.$route.query.topicKey){

      // }else{
      //   let detailId = {
      //     topicId: this.$route.query.topicId,
      //   };
      //   this.detailId = this.$route.query.topicId;
      // }

      // 是否游戏内跳转至详情页
      let _this = this;
      let getData = new Promise(function (resolve, reject) {
        let getDataInfo = {};
        if (_this.$route.query.topicKey) {
          getDataInfo = {
            topicId: 0,
            topicKey: _this.$route.query.topicKey
          };
        } else {
          getDataInfo = _this.$route.query.topicId;
        }
        _this.detailId = _this.$route.query.topicId;
        resolve(getDataInfo);
        reject(getDataInfo);
      });
      getData.then(function (res) {
        if (_this.$route.query.topicKey) {
          //游戏内跳转
          // 获取帖子详情
          get.getDetail2(res).then(res => {
            if (res.data.code == 0) {
              var _data = res.data.data;
              // 判断类型
              if (_data.videos && _data.videos.length > 0 && _data.source !== 'userRichText') {
                _this.isVideoPost = true;
                _this.$nextTick(() => {
                  if (_this.$store.state.isU3d) {
                    let img = new Image();
                    img.src = _data.videos[0].path + '.jpg';
                    img.onerror = () => {
                      _this.topPoster = require('@/assets/img/rich/t_cover2.jpg');
                    };
                    _this.topPoster = _data.videos[0].path + '.jpg';
                    return;
                  }
                  document.querySelector('.top_video').currentTime = _this.$store.state.videoProgress;
                  document.querySelector('.top_video').play();
                });
              }
              _this.shareData = _data;
              let _obj = [];
              _obj[0] = _data;
              getTime(_obj);
              _this.user = _obj[0];
              _this.jumpTopicId = _this.user.id;
              _this.user.commentNum = numberFormat(_this.user.commentNum);
              _this.user.goodNum = numberFormat(_this.user.goodNum);
              _this.imgList = [];
              // _this.videoList = []
              _this.user.pictures.forEach((item, index) => {
                item['class'] = _this.user.id;
                _this.imgList.push(item);
              });
              _this.$previewRefresh();
              _this.imgInit();
              _this.getList();
              _this.imgFun();
              _this.user.content = _this.user.content.replace(/<img class='emjoy'/g, `<emojimg`);
              if (_this.user.isOfficial != 0 || _this.user.source === 'userRichText') {
                _this.user.content = _this.user.content.replace(/<img/g, `<img preview=${_this.user.id} @click='imgClick'`);
              }
              _this.user.content = _this.user.content.replace(/<emojimg/g, `<img class='emjoy'`);
              _this.matchGlUrl();
              _this.actions = window.user.weixcode ? [{
                name: _this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: _this.user.isFans ? `取消关注 ${_this.user.memberNickName}` : `关注 ${_this.user.memberNickName}`
              }, {
                name: '投诉该内容'
              }] : [{
                name: '分享'
              }, {
                name: _this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: _this.user.isFans ? `取消关注 ${_this.user.memberNickName}` : `关注 ${_this.user.memberNickName}`
              }, {
                name: '投诉该内容'
              }];
              _this.$nextTick(() => {
                _this.transVideo();
              });
              // _this.user.content = _this.replaceVoteTag(_this.user.content);
              _this.createDynamicComponent(_this.user.content);
            } else if (res.data.code == 1004) {
              _this.flag = false;
            } else {
              // _this.errorMessage(res.data);
            }
            // if (_this)
          });
        } else {
          //帖子id跳转
          // 获取帖子详情
          get.getDetail(res).then(res => {
            if (res.data.code == 0) {
              var _data = res.data.data;
              // 判断类型
              if (_data.videos && _data.videos.length > 0 && _data.source !== 'userRichText') {
                _this.isVideoPost = true;
                _this.$nextTick(() => {
                  if (_this.$store.state.isU3d) {
                    let img = new Image();
                    img.src = _data.videos[0].path + '.jpg';
                    img.onerror = () => {
                      _this.topPoster = require('@/assets/img/rich/t_cover2.jpg');
                    };
                    _this.topPoster = _data.videos[0].path + '.jpg';
                    return;
                  }
                  document.querySelector('.top_video').currentTime = _this.$store.state.videoProgress;
                  document.querySelector('.top_video').play();
                });
              }
              _this.shareData = _data;
              let _obj = [];
              _obj[0] = _data;
              getTime(_obj);
              _this.user = _obj[0];
              _this.user.commentNum = numberFormat(_this.user.commentNum);
              _this.user.goodNum = numberFormat(_this.user.goodNum);
              _this.imgList = [];
              // _this.videoList = []
              _this.user.pictures.forEach((item, index) => {
                item['class'] = _this.user.id;
                _this.imgList.push(item);
              });
              _this.$previewRefresh();
              _this.imgInit();
              _this.getList();
              _this.imgFun();
              _this.user.content = _this.user.content.replace(/<img class='emjoy'/g, `<emojimg`);
              if (_this.user.isOfficial != 0 || _this.user.source === 'userRichText') {
                _this.user.content = _this.user.content.replace(/<img/g, `<img preview=${_this.user.id} @click='imgClick'`);
              }
              _this.user.content = _this.user.content.replace(/<emojimg/g, `<img class='emjoy'`);
              _this.user.content = _this.user.content.replace(/target="_blank"/g, 'target="_self"');
              _this.matchGlUrl();
              _this.actions = window.user.weixcode ? [{
                name: _this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: _this.user.isFans ? `取消关注 ${_this.user.memberNickName}` : `关注 ${_this.user.memberNickName}`
              }, {
                name: '投诉该内容'
              }] : [{
                name: '分享'
              }, {
                name: _this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: _this.user.isFans ? `取消关注 ${_this.user.memberNickName}` : `关注 ${_this.user.memberNickName}`
              }, {
                name: '投诉该内容'
              }];
              _this.$nextTick(() => {
                _this.transVideo();
              });
              _this.createDynamicComponent(_this.user.content);
              // _this.user.content = _this.replaceVoteTag(_this.user.content);
            } else if (res.data.code == 1004) {
              _this.flag = false;
            } else {
              // _this.errorMessage(res.data);
            }
            // if (_this)
          });
        }
        if (_this.$store.state.gameType != 5 && _this.$store.state.gameType != 2) {
          setTimeout(() => {
            // eslint-disable-next-line no-undef
            let anchorH = $('.detailsPage_messageTop').offset().top - 80;
            _this.anchorFlag ?
            // eslint-disable-next-line no-undef
            $('body,html').animate({
              scrollTop: anchorH
            }, 0) : '';
            _this.anchorFlag = false;
          }, 300);
        }
      });
    },
    // 处理富文本帖子中的视频
    transVideo() {
      let _this = this;
      let videos = document.querySelectorAll('video');
      if (this.$store.state.isInGame && this.$store.state.isU3d) {
        for (let i = 0; i < videos.length; i++) {
          setTimeout(() => {
            // let img = new Image()
            // img.src = videos[i].currentSrc + '.jpg'
            // img.onerror = () => {
            //   videos[i].poster = require('@/assets/img/rich/n_cover.jpg')
            // }
            videos[i].poster = videos[i].currentSrc + '.jpg';
          });
          videos[i].addEventListener('click', function (e) {
            _this.goUrl(e.target.currentSrc);
          });
        }
      } else {
        $('video').bind('contextmenu', function () {
          return false;
        });
        // $("video").poster()
        // let videos = document.querySelectorAll('video')
        for (let i = 0; i < videos.length; i++) {
          setTimeout(() => {
            videos[i].poster = videos[i].currentSrc + '.jpg';
          });
        }
      }
    },
    imgFun() {
      let _this = this;
      setTimeout(() => {
        $('.publishedContent').off().on('click', 'img', function () {
          let imgCon = [{
            id: 0,
            path: $(this).context.currentSrc
          }];
          _this.imgClick(true, imgCon, 0);
        });
      }, 300);
    },
    matchGlUrl() {
      if (this.$store.state.gameType == 2) {
        console.log('进入替换');
        let currentHost = window.location.host;
        let isQa = /^(test|qa)-/.test(location.hostname);
        let targetHost = currentHost.indexOf('ma-community') == -1 ? `//${isQa ? 'qa-' : ''}ma-community.tentree-games.com/` : `//${isQa ? 'qa-' : ''}community.zlongame.com/`;
        let needAppkey = currentHost.indexOf('ma-community') == -1;
        let reg = new RegExp(targetHost, 'g');
        if (needAppkey) {
          this.user.content = this.user.content.replace(reg, '//' + currentHost + '/index.html?appkey=1705460260139');
        } else {
          this.user.content = this.user.content.replace(reg, '//' + currentHost + '/');
        }
      }
    },
    // 获取帖子评论详情
    getList(cb, refresh) {
      // if (this.msgFinished && !refresh) return;
      let _this = this;
      // 获取查询评论列表
      let detailId = {
        topicId: this.$route.query.topicId || _this.jumpTopicId
      };
      let obj = {
        pageNo: this.msgPageNo,
        pageSize: 10,
        sortType: this.sortTypeNum
      };
      get.getCommentList(detailId.topicId, obj).then(res => {
        if (res.data.code == 0) {
          var _data = res.data.data;
          // 添加发帖人id
          _data.forEach((v, i) => {
            v.postsPosterId = this.user.memberId;
          });
          getTime(_data);
          if (_this.msgPageNo == 1) {
            _this.commentList = JSON.parse(JSON.stringify(_data));
          }
          _this.msgPageNo++;
          if (_data.length < 10) {
            _this.msgFinished = true;
            _this.msgPageNo > 1 ? _this.msgPageNo-- : '';
          }
          // this.commentList=JSON.parse(JSON.stringify(_data));
          cb && cb(JSON.parse(JSON.stringify(_data)));
        } else {
          this.errorMessage(res.data);
        }
      });
    },
    toMsgList() {
      if (this.$store.state.gameType != 5 && this.$store.state.gameType != 2) {
        let anchorH = $('.detailsPage_messageTop').offset().top - 80;
        $('body,html').animate({
          scrollTop: anchorH
        }, 0);
      }
    },
    //帖子点踩
    badClick: debounce(function () {
      get.bad(this.user.id).then(res => {
        let data = res.data;
        if (data.code == 0) {
          this.user.isBad = !this.user.isBad;
          if (this.user.isBad && this.user.isLike) {
            this.likeClick();
            this.getDetail();
          }
        } else {
          this.errorMessage(data.code);
        }
      });
    }, 500, {
      leading: true,
      trailing: false
    }),
    //收藏
    favor: debounce(function () {
      get.favor(this.user.id).then(res => {
        let data = res.data;
        if (data.code == 0) {
          let mes = '';
          this.user.isFavor = !this.user.isFavor;
          this.user.isFavor ? mes = '收藏成功' : mes = '取消收藏成功';
          _Toast(mes);
          this.user.isFavor ? this.actions[1].name = '取消收藏' : this.actions[1].name = '收藏';
        } else {
          this.errorMessage(data.code);
        }
      });
    }, 500, {
      leading: true,
      trailing: false
    }),
    likeChang() {
      this.user.isLike = !this.user.isLike;
      if (this.user.isLike) {
        this.user.goodNum++;
      } else {
        this.user.goodNum--;
      }
      if (this.user.isBad && this.user.isLike) {
        this.badClick();
      }
      // this.getDetail();
      // this.getGood(this.user.id);
    },
    //点赞
    likeClick: debounce(function () {
      get.likeClick(this.user.id).then(res => {
        let data = res.data;
        if (data.code == 0) {
          if (data.message == '点赞成功') {
            this.$refs.details_lickbtn.style.width = '.8rem';
            this.$refs.details_lickbtn.style.height = '.8rem';
            this.$refs.details_lickbtn.style.backgroundPosition = 'right';
            this.$refs.details_lickbtn.style.transition = `background .6s steps(28)`;
            setTimeout(() => {
              this.$refs.details_lickbtn.style.width = '.8rem';
              this.$refs.details_lickbtn.style.height = '.8rem';
              this.$refs.details_lickbtn.style.backgroundPosition = 'left';
              this.$refs.details_lickbtn.style.transition = `none`;
              this.likeChang();
            }, 600);
          } else {
            this.likeChang();
          }
        } else {
          this.errorMessage(data.code);
        }
      });
    }, 500, {
      leading: true,
      trailing: false
    }),
    //获取用户点赞列表
    getGood(id) {
      let obj = {
        pageNo: this.pageNo,
        pageSize: 20
      };
      get.likeMemberList(id, obj).then(res => {
        let data = res.data;
        if (data.code == 0) {
          this.user.likeMemberAvators = JSON.parse(JSON.stringify(data.data.list));
        } else {
          errorMessage(data);
        }
      });
    },
    //扩展点击事件
    vanActionFlag(flag, item) {
      if (flag == 2) {
        this.commentsFlag = true;
        this.commentsId = item.id;
        this.actions =
        // localStorage.getItem("memberId") == item.memberId
        this.$store.state.memberId == item.memberId ? this.actions = [{
          name: '删除'
        }] : [{
          name: '投诉该内容'
        }];
      } else {
        this.commentsFlag = false;
        // this.actions = window.user.weixcode
        //   ? this.$store.state.memberId == this.user.memberId
        //     ? (this.actions = [
        //       { name: this.user.isFavor ? "取消收藏" : "收藏" },
        //       { name: "删除" },
        //       { name: '编辑' }
        //     ])
        //     : [
        //       { name: this.user.isFavor ? "取消收藏" : "收藏" },
        //       {
        //         name: this.user.isFans
        //           ? `取消关注 ${this.user.memberNickName}`
        //           : `关注 ${this.user.memberNickName}`,
        //       },
        //       { name: "投诉该内容" },
        //     ]
        //   : this.$store.state.memberId == this.user.memberId
        //     ? (this.actions = [
        //       { name: "分享" },
        //       { name: this.user.isFavor ? "取消收藏" : "收藏" },
        //       { name: "删除" },
        //       { name: "编辑" }
        //     ])
        //     : [
        //       { name: "分享" },
        //       { name: this.user.isFavor ? "取消收藏" : "收藏" },
        //       {
        //         name: this.user.isFans
        //           ? `取消关注 ${this.user.memberNickName}`
        //           : `关注 ${this.user.memberNickName}`,
        //       },
        //       { name: "投诉该内容" },
        //     ];
        if (window.user.weixcode) {
          if (this.$store.state.memberId == this.user.memberId) {
            if (this.user.source === 'userRichText') {
              this.actions = [{
                name: this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: '编辑'
              }, {
                name: '删除'
              }];
            } else {
              this.actions = [{
                name: this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: '删除'
              }];
            }
          } else {
            this.actions = [{
              name: this.user.isFavor ? '取消收藏' : '收藏'
            }, {
              name: this.user.isFans ? `取消关注 ${this.user.memberNickName}` : `关注 ${this.user.memberNickName}`
            }, {
              name: '投诉该内容'
            }];
          }
        } else {
          if (this.$store.state.memberId == this.user.memberId) {
            if (this.user.source === 'userRichText') {
              this.actions = [{
                name: '分享'
              }, {
                name: this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: '编辑'
              }, {
                name: '删除'
              }];
            } else {
              this.actions = [{
                name: '分享'
              }, {
                name: this.user.isFavor ? '取消收藏' : '收藏'
              }, {
                name: '删除'
              }];
            }
          } else {
            this.actions = [{
              name: '分享'
            }, {
              name: this.user.isFavor ? '取消收藏' : '收藏'
            }, {
              name: this.user.isFans ? `取消关注 ${this.user.memberNickName}` : `关注 ${this.user.memberNickName}`
            }, {
              name: '投诉该内容'
            }];
          }
        }
      }
      this.show = true;
    },
    //底部弹出框点击
    onSelect(item) {
      this.show = false;
      switch (true) {
        case item.name == '分享':
          // if (this.$store.state.loginStatus == 0) {
          //   this.$store.commit('changeLoginShow', true);
          // } else {
          // }
          this.shareShowFlag(true);
          break;
        case item.name == '取消收藏' || item.name == '收藏':
          this.favor();
          break;
        case item.name == `关注 ${this.user.memberNickName}` || item.name == `取消关注 ${this.user.memberNickName}`:
          this.focusClick();
          break;
        case item.name == '投诉该内容':
          this.show_complaints = true;
          break;
        case item.name == '删除':
          this.onSelect_delete();
          break;
        case item.name == '编辑':
          this.onEditPost();
          break;
        default:
          break;
      }
    },
    onEditPost() {
      // 拿到cardId 和 类型，跳转对应编辑器
      if (this.user.source === 'userRichText') {
        if (this.$store.state.isPad) {
          this.$router.push({
            path: '/rich2',
            query: {
              postId: this.user.id
            }
          });
        } else {
          this.$router.push({
            path: '/rich',
            query: {
              postId: this.user.id
            }
          });
        }
      } else {
        this.$router.push({
          path: '/postPage',
          query: {
            postId: this.user.id
          }
        });
      }
      // this.$router.push('/')
    },
    //底部弹出框点击——举报
    onSelect_complaints(item) {
      let obj = {
        content: item.name,
        type: 1,
        originType: this.commentsFlag ? 2 : 1,
        originId: this.commentsFlag ? this.commentsId : this.user.id
      };
      get.report(qs.stringify(obj)).then(res => {
        let data = res.data;
        if (data.code == 0) {
          _Toast('举报成功');
        } else {
          this.errorMessage(data.code);
        }
      });
    },
    //底部弹出框点击——删除
    onSelect_delete() {
      let _this = this;
      if (this.commentsFlag) {
        //删除评论
        _Dialog.confirm({
          message: '确认删除该评论吗'
        }).then(() => {
          get.deleteComments(this.commentsId).then(res => {
            this.getDetail();
          });
        }).catch(() => {});
      } else {
        //删除帖子
        _Dialog.confirm({
          message: '确认删除该帖吗'
        }).then(() => {
          get.deletePost(this.user.id).then(res => {
            if (res.data.code == 0) {
              _Toast('删除成功');
              _this.backClick();
            }
          });
        }).catch(() => {});
      }
    },
    // 热门话题跳转
    toHotPage(item) {
      this.$router.push({
        name: 'subjectPage',
        query: {
          id: item.id,
          subjectName: item.subjectName,
          subjectType: item.subjectType,
          topicCommentNum: item.topicCommentNum,
          topicViewNum: item.topicViewNum
        }
      });
    },
    onCancel() {
      _Toast('取消');
    },
    backClick() {
      if (this.$route.query.isGame) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
      if (this.isVideoPost) {
        if (this.$store.state.isInGame && this.$store.state.isU3d) return;
        this.$store.commit('setVideoProgress', this.$refs.myvideo.currentTime);
        this.$store.commit('setVideoId', 'video' + this.$route.query.topicId);
      }
    },
    gohome() {
      //去首页
      this.$router.push('/home');
    },
    //删除评论图片
    removeFile() {
      this.msgWrapImg = '';
    },
    //图片上传
    addFile(e) {
      this.loadingFlag = true;
      let _this = this,
        file = e.target.files[0];
      if (file.size) {
        if ((file.size / (1024 * 1024)).toFixed(3) <= 15) {
          //小于5M
          file.newName = '_' + +new Date() + '.' + file.name.split('.')[1];
          try {
            file && _this.uploadFile(file, function (err, data) {
              if (data) {
                _this.msgWrapImg = data.url.replace('snspic-1251257918.cos.ap-shanghai.myqcloud.com', 'snspic.zlongame.com');
                _this.loadingFlag = false;
              } else {
                _Toast(err);
                _this.loadingFlag = false;
              }
            });
            // });
          } catch (err) {
            _Toast(err);
            _this.loadingFlag = false;
          }
        } else {
          _Toast('图片太大啦！请选择15M以内的图片上传哦~');
          _this.loadingFlag = false;
        }
      }
    },
    uploadFile(file, callback, obj) {
      var self = this;
      var Key =
      // "sns/front/" +
      new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + file.newName; // 这里指定上传目录和文件名
      self.getAuthorization({
        Method: 'PUT',
        Pathname: '/' + Key
      }, function (err, info) {
        if (err) {
          alert(err);
          return;
        }
        let prefix = self.protocol + '//' + self.Bucket + '.cos.' + self.Region + '.myqcloud.com/';
        var auth = info.Authorization;
        var XCosSecurityToken = info.XCosSecurityToken;
        var url = prefix + self.allowPrefix + self.camSafeUrlEncode(Key).replace(/%2F/g, '/');
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Authorization', auth);
        XCosSecurityToken && xhr.setRequestHeader('x-cos-security-token', XCosSecurityToken);
        xhr.upload.onprogress = function (e) {
          if (obj) {}
        };
        xhr.onload = function () {
          if (xhr.status === 200 || xhr.status === 206) {
            var ETag = xhr.getResponseHeader('etag');
            callback(null, {
              url: url,
              ETag: ETag
            });
          } else {
            callback('上传失败，状态码：' + xhr.status);
            this.loadingFlag = false;
          }
        };
        xhr.onerror = function () {
          callback('上传失败，请检查是否配置跨域规则');
          this.loadingFlag = false;
        };
        xhr.send(file);
      });
    },
    // 计算签名
    getAuthorization(options, callback) {
      get.getCosTemToken().then(res => {
        var data;
        try {
          data = new Function('return ' + JSON.stringify(res.data.data))();
          this.allowPrefix = data.allowPrefix;
          this.Region = data.region;
          this.Bucket = data.bucketName;
        } catch (res) {
          this.loadingFlag = false;
        }
        if (data) {
          callback(null, {
            XCosSecurityToken: data.credentials.sessionToken,
            Authorization: CosAuth({
              SecretId: data.credentials.tmpSecretId,
              SecretKey: data.credentials.tmpSecretKey,
              Method: options.Method,
              Pathname: options.Pathname
            })
          });
        } else {
          callback('获取签名出错');
          this.loadingFlag = false;
        }
      });
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A');
    },
    // 评论下拉刷新
    onRefresh() {
      this.anchorFlag = false;
      this.msgPageNo = 1;
      // setTimeout(() => {
      this.getDetail();
      // Toast("刷新成功");
      this.isLoading = false;
      // }, 1000);
    },
    // 评论下滑加载
    msgOnLoad(isComment, flag) {
      let _this = this;
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      if (isComment === false && !isComment) {
        //更新回复评论数据
        setTimeout(() => {
          _this.getList(function (data) {
            // 加载状态结束
            //更新回复的评论自身数据
            _this.commentList[_this.currentFloorIndex] = data[_this.currentFloorIndex % 10];
            //深层数据更新无法传递到子组件之中
            //手动更新 评论回复列表 和评论回复数
            _this.$refs.message[_this.currentFloorIndex]._data.replyCommentList = data[_this.currentFloorIndex % 10].replyCommentList;
            _this.$refs.message[_this.currentFloorIndex]._data.messagereply.replyNum = data[_this.currentFloorIndex % 10].replyNum;
          }, flag);
          _this.$refs.message[_this.currentFloorIndex].messagereplyFlag = true;
        }, 100);
      } else {
        //更新评论数据
        setTimeout(() => {
          _this.getList(function (data) {
            // 加载状态结束
            _this.commentList = _this.commentList.concat(data);
            _this.commentList = arrNewSet(_this.commentList);
            _this.msgLoading = false;
            // 数据全部加载完成
            if (data.length < 10) {
              _this.msgFinished = true;
            }
          });
        }, 100);
      }
    },
    vueTouch(text, e) {
      // this.msgFinished = false;
      this.msgLoading = true;
      setTimeout(() => {
        this.msgOnLoad();
      }, 100);
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050 && code != undefined) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        _Toast(msg);
      }
    }
  }
};